import React from 'react';
import { Card } from '../ui/card';

export function AdminUsersTab({ users }) {
  return (
    <>
      <h2 className='text-2xl font-bold text-[#1A3C34] mb-6' style={{ fontFamily: 'Clash Display' }}>User Management</h2>
      <Card className='bg-white rounded-2xl p-6'>
        <div className='space-y-4'>
          {users.map((u, index) => (
            <div key={u.id} className='flex justify-between items-center py-3 border-b last:border-0' data-testid={`user-row-${index}`}>
              <div>
                <div className='font-medium text-[#1A3C34]'>{u.name}</div>
                <div className='text-sm text-gray-600'>{u.email}</div>
              </div>
              <div className='flex items-center gap-4'>
                <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                  u.subscription_status === 'active' 
                    ? 'bg-[#D4F246] text-[#1A3C34]' 
                    : 'bg-gray-200 text-gray-600'
                }`}>
                  {u.subscription_status || 'inactive'}
                </span>
                <span className={`px-3 py-1 rounded-full text-xs ${
                  u.role === 'admin' 
                    ? 'bg-[#1A3C34] text-white' 
                    : 'bg-gray-100 text-gray-600'
                }`}>
                  {u.role}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
}
